import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {GlobalConstants} from '../global-constants';
import {Observable} from 'rxjs';
import {Location} from "./tools.models";

@Injectable({
    providedIn: 'root'
})
export class ToolsService {

    constructor(private http: HttpClient) {
    }

    findAllLocations(): Observable<Array<Location>> {
        return this.http.get<Array<Location>>(`${GlobalConstants.apiURL}/locations`);
    }

    reconcileJournals(request: any[], synchronizeMappings): Observable<void> {
        return this.http.post<void>(
            `${GlobalConstants.apiURL}/api/reconciliation/recreateJournals?forceExtract=true&fetchMappings=${synchronizeMappings}`, request);
    }
}
